import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueToast from 'vue-toast-notification'
import VueGoodTablePlugin from 'vue-good-table'
import VModal from 'vue-js-modal'
import VLoading from 'vuejs-loading-screen'
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import 'vue-toast-notification/dist/theme-default.css'
import './assets/css/main.css'
import './assets/css/design-system.css'
import './assets/css/workspace-theme.css'
import './assets/css/pwa.css'
import './assets/css/vs2015.css'
import './assets/fontawesome/css/all.min.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import { adminTemplate } from './adminTemplate'
import i18n from './i18n'
import PageLayout from '@/components/layouts/PageLayout.vue'
import ContentCard from '@/components/layouts/ContentCard.vue'
import { bootstrapAuthHeader } from '@/api/http'
import { bindPWAInstallPrompt, isStandaloneDisplay } from '@/lib/pwa'
import './registerServiceWorker'

i18n.locale = 'id'

Vue.component('PageLayout', PageLayout)
Vue.component('ContentCard', ContentCard)

Vue.use(VueToast)
Vue.use(VueGoodTablePlugin)
Vue.use(VModal)
Vue.use(VLoading)
Vue.use(PerfectScrollbar)

Vue.config.productionTip = false
Vue.prototype.$adminTemplate = adminTemplate

bootstrapAuthHeader()
bindPWAInstallPrompt()
if (isStandaloneDisplay()) {
  document.documentElement.classList.add('pwa-standalone')
  document.body.classList.add('pwa-standalone')
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
